import { render, staticRenderFns } from "./tabBillingGroup.vue?vue&type=template&id=374d3475&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./tabBillingGroup.vue?vue&type=script&lang=js&"
export * from "./tabBillingGroup.vue?vue&type=script&lang=js&"
import style0 from "./tabBillingGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('374d3475')) {
      api.createRecord('374d3475', component.options)
    } else {
      api.reload('374d3475', component.options)
    }
    module.hot.accept("./tabBillingGroup.vue?vue&type=template&id=374d3475&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('374d3475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillingNative/tabBillingGroup.vue"
export default component.exports